<template>
  <div>
    <div class="backImg" v-show="$store.state.bgImg">
      <img src="@/assets/index/bgImg.jpg" :style="'height:'+ height" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "backImg",
  props: {
    height: {
      type: String,
      default: '100%'
    }
  }
}
</script>

<style scoped>
  .backImg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    > img {
      width: 100%;
    }
  }
</style>
